import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-thankyou',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.css']
})
export class ThankyouComponent implements OnInit {

  @Input() userData;
  name;
  email;

  constructor(private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {

    //Thank you page overflow issue on page resize fix
    $(window).on('load resize',function(){
      console.log($('#thankyoupage').height())
      if (($('#thankyoupage').height()+90) > $(window).innerHeight()){
        $('#thankyoupage').css({'position':'relative','transform':'translateY(0)'});
      }
      else{
        $('#thankyoupage').css({ 'position': 'absolute', 'transform': 'translateY(-50%)'});
      }
    })
    if(this.userData){
      this.name = this.userData.firstName;
      this.email = this.userData.email;
    } else{
      console.log('Thank you : ', this.route);
      this.name = this.route.snapshot.queryParams['name'];
      this.email = this.route.snapshot.queryParams['email'];
    }

    sessionStorage.removeItem('buildingImage');
    sessionStorage.removeItem('userImage');
    sessionStorage.removeItem('groupImage');
    sessionStorage.removeItem('existingBuildingImage');
    sessionStorage.clear();

    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };

  }

}
